import { render, staticRenderFns } from "./ScwlWaybillDayChart.vue?vue&type=template&id=365276cb&scoped=true"
import script from "./ScwlWaybillDayChart.vue?vue&type=script&lang=js"
export * from "./ScwlWaybillDayChart.vue?vue&type=script&lang=js"
import style0 from "./ScwlWaybillDayChart.vue?vue&type=style&index=0&id=365276cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365276cb",
  null
  
)

export default component.exports